import type {
  NewRelicConfig,
  NewRelicInfo,
  NewRelicSettings
} from "@dealer-center/core-interfaces-third-party-newrelic";

export const buildDistTrackingScript = ({
  distributedTracing,
  excludeNewRelicHeader,
  corsEnabled,
  corsUseNewRelicHeader,
  corsUseTraceContextHeaders,
  allowedOrigins
}: NewRelicSettings) => {
  type KVP = [key: string, value: boolean | string];
  const newRelicDistributedTracingObject: KVP[] = [];
  if (!distributedTracing)
    return ';window.NREUM||(NREUM={});NREUM.init={privacy:{cookies_enabled:true},ajax:{deny_list:["bam.nr-data.net"]}};';
  newRelicDistributedTracingObject.push(["enabled", true]);
  if (excludeNewRelicHeader)
    newRelicDistributedTracingObject.push([
      "exclude_newrelic_header",
      excludeNewRelicHeader
    ]);
  if (corsEnabled) {
    newRelicDistributedTracingObject.push([
      "cors_use_newrelic_header",
      corsUseNewRelicHeader ?? false
    ]);
    newRelicDistributedTracingObject.push([
      "cors_use_tracecontext_headers",
      corsUseTraceContextHeaders ?? false
    ]);
    if (allowedOrigins && allowedOrigins.length > 0)
      newRelicDistributedTracingObject.push([
        "allowed_origins",
        `['${allowedOrigins.join("','")}']`
      ]);
  }
  return `;window.NREUM||(NREUM={});NREUM.init={distributed_tracing:{${newRelicDistributedTracingObject
    .map(value => `${value[0]}:${value[1]}`)
    .toString()}},privacy:{cookies_enabled:true},ajax:{deny_list:["bam.nr-data.net"]}};`;
};

// Mostly taken from newrelic, but with also a replace of \ with \\
const scriptBuilder = (
  loaderConfig: NewRelicConfig,
  infoConfig: NewRelicInfo
) => {
  const {
    agentID,
    accountID,
    applicationID,
    licenseKey,
    trustKey,
    allowedOrigins,
    corsUseNewRelicHeader,
    corsUseTraceContextHeaders,
    distributedTracing,
    excludeNewRelicHeader,
    corsEnabled
  } = loaderConfig;
  const { beacon, errorBeacon, sa } = infoConfig;

  const script: string[] = [];

  script.push(
    buildDistTrackingScript({
      distributedTracing,
      excludeNewRelicHeader,
      corsEnabled,
      corsUseNewRelicHeader,
      corsUseTraceContextHeaders,
      allowedOrigins
    })
  );
  script.push(
    `;NREUM.loader_config={accountID:"${accountID}",trustKey:"${trustKey}",agentID:"${agentID}",licenseKey:"${licenseKey}",applicationID:"${applicationID}"}`
  );
  script.push(
    `;NREUM.info={beacon:"${beacon}",errorBeacon:"${errorBeacon}",licenseKey:"${licenseKey}",applicationID:"${applicationID}",sa:${sa}}`
  );
  // script.push(newRelicBulkScript);

  return script.join("");
};
export default scriptBuilder;
